import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {Estado} from '../../../../domain/estado';
import {FormService} from '../../../../services/formServices';
import {FormControl, FormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {Sort} from '../../../../domain/sort/sort';
import { ModalDirective, ModalOptions } from 'angular-bootstrap-md';
import { Response } from '../../../../domain/Response';

@Component({
  selector: 'app-select-state',
  templateUrl: './select-state.component.html',
  styleUrls: ['./select-state.component.scss']
})
export class SelectStateComponent implements OnInit {
    @Input('id')id: number;
    @Input('titulo')titulo: string;
    @Input('type')type: string;
    @Input('rol')rol: string;
    @Input('email')email: string;
    @Input('selected')selected: number;
    @Output('actualizar')actualizar = new EventEmitter();
    sort: Sort;
    main: Array<Estado>;
    data: any;
    preselected: number;
    myform: FormGroup;
    disabled: Boolean;
    @ViewChild('demoBasic') demoBasic: ModalDirective;
    modalConfigDefaults: ModalOptions = {
        backdrop: false,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: '',
        animated: true
      };
    constructor(private formService: FormService, private toastr: ToastrService) {
        
    }

    ngOnInit(): void {
        this.demoBasic.config = this.modalConfigDefaults;
        this.sort = new Sort();
        this.preselected = this.selected;
        if ((this.rol!='admin' && this.type == 'finalizados') || (this.rol =='admin' && this.type == 'notificados')) {
            this.disabled = true;
        }
        switch(this.type) {
            case 'finalizados': {
                this.formService.getEstadosFinalizados().subscribe(
                    data => {
                        this.main = this.sort.sortOrden(data);
                    }
                );
                break;
            }
            case 'reabiertos': {
                this.formService.getEstadosReabierto().subscribe(
                    data => {
                        this.main = this.sort.sortOrden(data);
                    }
                );
                break;
            }
            case 'asignados': {
                this.formService.getEstadosAsignados().subscribe(
                    data => {
                        this.main = this.sort.sortOrden(data);
                    }
                );
                break;
            }
            case 'ingresados': {
                this.formService.getEstadosIngresados().subscribe(
                    data => {
                        this.main = this.sort.sortOrden(data);
                    }
                );
                break;
            }
            case 'notificados': {
                this.formService.getEstadosIngresados().subscribe(
                    data => {
                        this.main = this.sort.sortOrden(data);
                    }
                );
                break;
            }
        }
        this.myform = new FormGroup({
            descripcion: new FormControl('')
        });
    }

    onChange(element: any) {
        if (this.selected === 3 || this.selected === 4 ) {
            element.show();
        } else if (this.selected == 6){
            this.formService.mailReabierto({id: this.id}).subscribe(
                (datax: Response) => {
                    if(datax.error != ''){
                        this.cerrarVentana(element);
                        this.toastr.error(datax.error, 'Error');
                    }else {
                    this.disabled = true;
                    this.toastr.success('El ejecutor actualmente asignado fue notificado del ticket reabierto', 'Exito');
                    element.hide();
                    this.data = { 'id': this.id, 'estado': this.selected};
                    this.cambiarEstado();
                    }
                },
                error => this.toastr.error('Ha ocurrido un error en el envio!', 'error')
            );
        } else {
            this.data = { 'id': this.id, 'estado': this.selected};
            this.disabled = false;
            this.cambiarEstado();
        }
    }

    cambiarEstado() {
        this.formService.updateEstado(this.data).subscribe(
            datax => {
                this.preselected = this.selected;
                this.toastr.success('Estado modificado!', 'Exito');
                this.actualizarVista();
            },
            error => this.toastr.error('Ha ocurrido un error en la actualización!', 'error')
        );
    }

    enviarFinDeTicket(elem) {
        const fecha_finalizado = new Date();
        const data = { mensaje: this.myform.value, fecha_finalizado: fecha_finalizado, id: this.id,  email: this.email};
        if(this.myform.value.descripcion == null || this.myform.value.descripcion == '' ) {
            this.toastr.error('Para enviar el email debe completar antes el campo descripción', 'error');
        } else {
        this.formService.mailFinDeTicket(data).subscribe(
            datax => {
                this.disabled = true;
                this.toastr.success('Envio realizado!', 'Exito');
                elem.hide();
                this.data = { 'id': this.id, 'estado': this.selected};
                this.cambiarEstado();
            },
            error => this.toastr.error('Ha ocurrido un error en el envio!', 'error')
        );
    }
    }

    actualizarVista() {
        this.actualizar.emit(true);
    }

    cerrarVentana(elem){
        this.selected = this.preselected;
        elem.hide();
        this.actualizar.emit(false);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/selects/modificar/select-state/select-state.component.ts